module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "overflow": "auto",
      "margin-top": "2rem"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-half-tablet is-one-third-desktop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    attrs: {
      "id": "fromData"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('h2', {
    staticClass: "has-text-primary has-text-centered"
  }, [_vm._v("Welcome to ChangeVU!")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "intro-text"
  }, [_vm._v("\n              Please add and confirm your password to complete your account set up.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your name")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your first name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Your last name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "confirmPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox help has-text-grey"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.agree),
      expression: "user.agree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.agree) ? _vm._i(_vm.user.agree, null) > -1 : (_vm.user.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "agree", $$c)
        }
      }
    }
  }), _vm._v("\n                  I agree to the "), _c('a', {
    attrs: {
      "href": "#/terms",
      "target": "_blank"
    }
  }, [_vm._v("ChangeVU Terms of Use")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control progress-btn"
  }, [(!_vm.isInvited) ? _c('span', [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("Already have an account?")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-primary btnRight",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onBoard()
      }
    }
  }, [_vm._v("Done "), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_vm._v("& Do My Assessment")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-centered has-text-white"
  }, [_c('span', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("FREE TRIAL! TEAM CHANGE RISK ASSESSMENT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f37f5d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/OnBoardMember.vue
// module id = 371
// module chunks = 5